import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseGetByComanyRequest, IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateInstallationRequest, IGetInstallationDetailResponse, IGetInstallationResponse, IGetInstallationsByCompanyRequest, IUpdateInstallationRequest } from '../models/installation';


@Injectable({
  providedIn: 'root'
})
export class InstallationService {

  constructor(private http: HttpClient) { }

  // Installation
  createInstallation(request: ICreateInstallationRequest) {
    return this.http.post<IGetInstallationResponse>(
      `${environment.baseUrl}/v1/installations/createInstallation`,
      request
    )
  }

  searchInstallations(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IGetInstallationResponse[]>>(
      `${environment.baseUrl}/v1/installations/searchInstallations`,
      request
    )
  }

  getInstallationById(id: string){
    return this.http.get<IGetInstallationDetailResponse>(
      `${environment.baseUrl}/v1/installations/getInstallation/${id}`
    )
  }

  getInstallationsByCompany(request: IGetInstallationsByCompanyRequest){
    return this.http.post<IPagedResults<IGetInstallationResponse[]>>(
      `${environment.baseUrl}/v1/installations/getInstallationsByCompany`,
      request
    )
  }

  updateInstallation(request: IUpdateInstallationRequest){
    return this.http.put<IGetInstallationResponse>(
      `${environment.baseUrl}/v1/installations/updateInstallation/${request.id}`,
      request
    )
  }

  deleteInstallation(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/installations/deleteInstallation/${id}`
    )
  }
}